import React from 'react';
import { ModuleBridge, TopActionBar, ReportDateRangePicker } from '../components';

export const ReportingMigrationByUser = () => {
    return (
        <>
            <TopActionBar>
                <ReportDateRangePicker />
            </TopActionBar>
            <div id="backbone_reporting_wrapper"></div>
            <ModuleBridge moduleId="reporting_migration_by_user_module" />
        </>
    );
};
